// extracted by mini-css-extract-plugin
export var btn = "B_b";
export var menuItem = "B_1";
export var menuItemLink = "B_2";
export var menuList = "B_0";
export var menuNav = "B_Z";
export var smooth = "B_d";
export var submit = "B_c";